import { GraduatingClass as GraduatingClassType } from '../utils/data_types';
import React from 'react';
import styled from 'styled-components/macro';
import { THEME_COLORS } from '../utils/theme';
import { SectionBannerPink, SectionHeader } from './styles';
import PieChart from './graphs/PieChart';

interface Props {
  classData: GraduatingClassType;
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Graph = styled.div`
  width: 70vw;
  min-width: 0;
  min-height: 0;
  margin: 15px;
  padding: 15px;
`;

interface Props {
  classData: GraduatingClassType;
}

export const GraduatingClass: React.FC<Props> = props => {
  let data = props.classData;
  return (
    <>
      <SectionBannerPink>
        <SectionHeader color={THEME_COLORS.headerWhite}>Graduating Class</SectionHeader>
        <Container>
          <Graph>
            <PieChart
              sliceNames={['Freshman', 'Sophomore', 'Junior', 'Senior']}
              data={[data.yearFreshman, data.yearSophomore, data.yearJunior, data.yearSenior || 0]}
              show_legend={true}
              show_percentages={true}
              hover_num={180}
              show_leg_percentage={false}
              show_legend_first={true}
            />
          </Graph>
        </Container>
      </SectionBannerPink>
    </>
  );
};
